import *  as htmlToImage from "html-to-image";
// Export template data to JSON format 
// Export template data to JSON format
export const exportToJson = (elements, designName, storeId, tenantId, siteId, canvasDimensions) => {
  return {
    name: designName,
    store_id: storeId || "store_101",
    tenantId: tenantId || "",
    siteId: siteId,
    type: "visual",
    canvas: {
      width: canvasDimensions?.width,
      height: canvasDimensions?.height
    },
    elements: elements.map(element => {
      // Spread original element to preserve all fields (like group)
      const baseElement = {
        ...element,
        id: `el-${element.id}`,
        type: element.type === 'shape' ? (element.shapeType === 'circle' ? 'circle' : 'rectangle') : element.type,
        x: element.x,
        y: element.y,
        fill: element.fill
      };

      switch (element.type) {
        case 'text':
          return {
            ...baseElement,
            text: element.content || "",
            fontSize: element.fontSize,
            fontFamily: element.fontFamily,
            fontWeight: element.fontWeight,
            fontStyle: element.fontStyle,
            textAlign: element.textAlign || 'left',
            color: element.fill || element.color,
            width: element.width,
            height: element.height,
            attribute_binding: element.attribute_binding || { data_key: "" },
            rotation: element.rotation || 0
          };

        case 'shape':
          return {
            ...baseElement,
            width: element.width,
            height: element.height,
            attribute_binding: element.attribute_binding || {
              data_key: "",
              color_logic: [
                { condition: "< 30", color: "#00FF00" },
                { condition: ">= 30", color: "#FF0000" }
              ]
            },
            rotation: element.rotation || 0

          };

        case 'image':
          return {
            ...baseElement,
            width: element.width,
            height: element.height,
            src: element.src,
            ditheringEnabled: element.ditheringEnabled !== false,
            attribute_binding: element.attribute_binding || null,
            rotation: element.rotation || 0
          };

        case 'qr':
          return {
            ...baseElement,
            width: element.width,
            height: element.height,
            url: element.url,
            imgUrl: element.imgUrl,
            rotation: element.rotation || 0
          };

        case 'line':
          return {
            ...baseElement,
            width: element.width,
            height: element.height,
            direction: element.direction,
            rotation: element.rotation || 0
          };

        case 'icons':
        case 'labels':
          return {
            ...baseElement,
            type: 'labels',
            width: element.width,
            height: element.height,
            rotation: element.rotation || 0,
            direction: element.direction || 'row',
            maxCount: element.maxCount,
            alignment: element.alignment || 'left',
            ditheringEnabled: element.ditheringEnabled ?? false,
          };

        default:
          return baseElement;
      }
    })
  };
};


// Import template data from JSON format
export const importFromJson = (templateData) => {
  if (!templateData || !templateData.elements) {
    return [];
  }

  return templateData.elements.map(element => {
    // Remove 'el-' prefix and convert to number for internal use
    const id = element.id.replace('el-', '');
    const numericId = parseInt(id) || Date.now();

    const baseElement = {
      id: numericId,
      x: element.x || 0,
      y: element.y || 0
    };

    switch (element.type) {
      case 'text':
        return {
          ...baseElement,
          type: 'text',
          fill: element.fill,
          width: element.width,
          height: element.height,
          content: element.text,
          fontSize: element.fontSize,
          fontFamily: element.fontFamily,
          fontWeight: element.fontWeight,
          fontStyle: element.fontStyle,
          textAlign: element.textAlign,
          textCase: element.textCase || null,
          attribute_binding: element.attribute_binding || null,
          group: element.group || null,
          rotation: element.rotation !== undefined ? element.rotation : 0,
          verticalAlign: element.verticalAlign || "center"
        };

      case 'rectangle':
        return {
          ...baseElement,
          type: 'shape',
          shapeType: 'rectangle',
          width: element.width,
          height: element.height,
          fill: element.fill,
          attribute_binding: element.attribute_binding || null,
          group: element.group || null,
          rotation: element.rotation !== undefined ? element.rotation : 0,
        };

      case 'circle':
        return {
          ...baseElement,
          type: 'shape',
          shapeType: 'circle',
          width: element.width,
          height: element.height,
          fill: element.fill,
          attribute_binding: element.attribute_binding || null,
          group: element.group || null,
          rotation: element.rotation !== undefined ? element.rotation : 0,
        };

      case 'image':
        return {
          ...baseElement,
          type: 'image',
          width: element.width,
          height: element.height,
          src: element.src || '',
          ditheringEnabled: element.ditheringEnabled !== false,
          attribute_binding: element.attribute_binding || null,
          group: element.group || null,
          rotation: element.rotation !== undefined ? element.rotation : 0,
        };

      case 'qr':
        return {
          ...baseElement,
          type: 'qr',
          width: element.width,
          height: element.height,
          url: element.url || 'https://example.com',
          imgUrl: element.imgUrl,
          fill: element.fill || '#000000',
          group: element.group || null,
          rotation: element.rotation !== undefined ? element.rotation : 0,
        };

      case 'line':
        return {
          ...baseElement,
          type: 'line',
          width: element.width,
          height: element.height,
          direction: element.direction,
          fill: element.fill || '#000000',
          group: element.group || null,
          rotation: element.rotation !== undefined ? element.rotation : 0,
        };

      case 'icons':
      case 'labels':
        return {
          ...baseElement,
          type: 'labels',
          width: element.width,
          height: element.height,
          group: element.group || null,
          rotation: element.rotation !== undefined ? element.rotation : 0,
          direction: element.direction || 'row',
          maxCount: element.maxCount,
          alignment: element.alignment || 'left',
          ditheringEnabled: element.ditheringEnabled ?? false,
        };

      default:
        // Fallback for unknown types
        return {
          ...baseElement,
          type: element.type,
          width: element.width,
          height: element.height,
          group: element.group || null,
          rotation: element.rotation !== undefined ? element.rotation : 0,
        };
    }
  });
};

// Parses a resolution string (e.g., "1920x1080") into a width and height object.
export const parseResolution = (resolution) => {
  if (!resolution) return { width: 1920, height: 1080 };
  const [width, height] = resolution.split("x").map(Number);
  return { width, height };
};

// Calculates the optimal canvas dimensions to fit within a specified container.
// Returns the true canvas dimensions for the chosen resolution.
// Rendering components are responsible for scaling visually to fit.
export const calculateCanvasDimensions = (resolution) => {
  const { width, height } = parseResolution(resolution);
  return { width, height };
};

// Generates a PNG image of the canvas element.
export const generateCanvasImage = async (elements, resolution) => {
  if (!elements || elements.length === 0) {
    return "";
  }

  const { width, height } = parseResolution(resolution);
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");

  for (const el of elements) {
    if (el.type === "image" && el.src) {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = el.src;
      await new Promise((res, rej) => {
        img.onload = () => {
          ctx.drawImage(img, el.x, el.y, el.width, el.height);
          res();
        };
        img.onerror = rej;
      });
    }
    if (el.type === "text" && el.text) {
      ctx.font = `${el.fontWeight || 'normal'} ${el.fontSize || 16}px ${el.fontFamily || 'Arial'}`;
      ctx.fillStyle = el.fill || "#000";
      ctx.textAlign = el.textAlign || "left";
      ctx.fillText(el.text, el.x, el.y + (el.fontSize || 16));
    }
    if (el.type === "rectangle" || el.type === "circle") {
      ctx.fillStyle = el.fill || "#000";
      ctx.fillRect(el.x, el.y, el.width, el.height);
    }
    if (el.type === "line") {
      ctx.strokeStyle = el.fill || "#000";
      ctx.lineWidth = 2;
      ctx.beginPath();
      if (el.direction === "horizontal") {
        ctx.moveTo(el.x, el.y + el.height / 2);
        ctx.lineTo(el.x + el.width, el.y + el.height / 2);
      } else {
        ctx.moveTo(el.x + el.width / 2, el.y);
        ctx.lineTo(el.x + el.width / 2, el.y + el.height);
      }
      ctx.stroke();
    }
    if (el.type === "qr") {
      const qrImg = new Image();
      qrImg.crossOrigin = "anonymous";
      qrImg.src = el.imgUrl;
      await new Promise((res, rej) => {
        qrImg.onload = () => {
          ctx.drawImage(qrImg, el.x, el.y, el.width, el.height);
          res();
        };
        qrImg.onerror = rej;
      });
    }
  }

  return canvas.toDataURL("image/png");
};

// download canvas as a image
export const downloadGenerateCanvasImage = async (canvasRef, resolution) => {
  const { width, height } = parseResolution(resolution);
  if (!canvasRef.current) return null;

  try {
    await new Promise((resolve) => setTimeout(resolve, 50));

    const node = canvasRef.current;

    const dataUrl = await htmlToImage.toPng(node, {
      quality: 1,
      pixelRatio: 3,
      backgroundColor: "#ffffff",
      style: {
        width: `${width}px`,
        height: `${height}px`,
        transform: "scale(1)",
        transformOrigin: "top left",
      },
    });

    return dataUrl;
  } catch (error) {
    console.error("Error generating design image:", error);
    return null;
  }
};


